import { c as _c } from "react/compiler-runtime";
import type { MaterialNameType } from "@website/icons/material";
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
type TimelineItamProperties = {
  title: string;
  detail: string;
  iconName: MaterialNameType;
  hideTopLine?: boolean;
  hideBottomLine?: boolean;
  stepNumber: number;
};
const Line = t0 => {
  const $ = _c(2);
  const {
    hide
  } = t0;
  if (hide) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="h-[24px] w-px" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-states-neutral-focus h-[24px] w-px border" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const TimelineItem = t0 => {
  const $ = _c(42);
  const {
    title,
    detail,
    iconName,
    hideTopLine,
    hideBottomLine,
    stepNumber
  } = t0;
  let t1;
  if ($[0] !== hideTopLine) {
    t1 = <Line hide={hideTopLine} />;
    $[0] = hideTopLine;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== iconName) {
    t2 = <div className="border-states-neutral-focus text-on-surface-disable flex size-10 items-center justify-center rounded-full border text-2xl"><MaterialIcon name={iconName} variant="outlined" /></div>;
    $[2] = iconName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hideBottomLine) {
    t3 = <Line hide={hideBottomLine} />;
    $[4] = hideBottomLine;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex flex-col items-center gap-y-2">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== title) {
    t5 = <div className="text-on-surface-high-emphasis text-button">{title}</div>;
    $[10] = title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== detail) {
    t6 = <div className="text-on-surface-medium-emphasis text-overline">{detail}</div>;
    $[12] = detail;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="flex flex-col gap-y-2">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t7) {
    t8 = <li className="flex h-[88px] items-center gap-x-2 sm:hidden">{t4}{t7}</li>;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== stepNumber) {
    t9 = numberConvert(stepNumber, {
      locale: "fa"
    });
    $[20] = stepNumber;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <div className="flex flex-col items-center gap-y-2"><div className="border-states-neutral-focus text-subtitle-1 flex size-10 items-center justify-center rounded-full border">{t9}</div></div>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== title) {
    t11 = <div className="text-on-surface-high-emphasis text-button">{title}</div>;
    $[24] = title;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== detail) {
    t12 = <div className="text-on-surface-medium-emphasis text-caption">{detail}</div>;
    $[26] = detail;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <div className="flex flex-col gap-y-2">{t11}{t12}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t10 || $[32] !== t13) {
    t14 = <div className="flex gap-4">{t10}{t13}</div>;
    $[31] = t10;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== iconName) {
    t15 = <div className="text-on-surface-disable text-3xl"><MaterialIcon name={iconName} variant="outlined" /></div>;
    $[34] = iconName;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t14 || $[37] !== t15) {
    t16 = <li className="border-outline-thin flex items-center justify-between rounded-xl border px-6 py-4 max-sm:hidden">{t14}{t15}</li>;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t16 || $[40] !== t8) {
    t17 = <>{t8}{t16}</>;
    $[39] = t16;
    $[40] = t8;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
};
export const Timeline = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ol className="pt-3 sm:flex sm:flex-col sm:gap-3 md:pt-8"><TimelineItem detail={"\u062B\u0628\u062A \u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0627\u0648\u0644\u06CC\u0647 \u0648 \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u062A\u0645\u0627\u0633"} hideTopLine={true} iconName="assignment" stepNumber={1} title={"\u062B\u0628\u062A \u062F\u0631\u062E\u0648\u0627\u0633\u062A"} /><TimelineItem detail={"\u062B\u0628\u062A \u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0627\u0648\u0644\u06CC\u0647 \u0648 \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u062A\u0645\u0627\u0633"} iconName="call" stepNumber={2} title={"\u062B\u0628\u062A \u062F\u0631\u062E\u0648\u0627\u0633\u062A"} /><TimelineItem detail={"\u0645\u062F\u0627\u0631\u06A9 \u0648 \u0627\u0633\u0646\u0627\u062F \u062E\u0648\u062F \u0631\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0648 \u0627\u0631\u0633\u0627\u0644 \u06A9\u0646\u06CC\u062F."} iconName="upload" stepNumber={3} title={"\u0627\u0631\u0633\u0627\u0644 \u0645\u062F\u0627\u0631\u06A9 \u0628\u0647 \u0627\u06CC\u0645\u06CC\u0644"} /><TimelineItem detail={"\u0647\u0632\u06CC\u0646\u0647 \u0648\u06CC\u0632\u0627 \u0628\u0647 \u0635\u0648\u0631\u062A \u0631\u06CC\u0627\u0644\u06CC \u0648 \u0622\u0646\u0644\u0627\u06CC\u0646 \u062F\u0631\u06CC\u0627\u0641\u062A \u0645\u06CC\u200C\u0634\u0648\u062F."} iconName="payments" stepNumber={4} title={"\u067E\u0631\u062F\u0627\u062E\u062A \u0647\u0632\u06CC\u0646\u0647"} /><TimelineItem detail={"\u0645\u062F\u0627\u0631\u06A9 \u0634\u0645\u0627 \u0628\u0631\u0627\u06CC \u0633\u0641\u0627\u0631\u062A \u0627\u0631\u0633\u0627\u0644 \u062E\u0648\u0627\u0647\u062F \u0634\u062F."} iconName="pending_actions" stepNumber={5} title={"\u067E\u0631\u062F\u0627\u0632\u0634 \u0648\u06CC\u0632\u0627"} /><TimelineItem detail={"\u0648\u06CC\u0632\u0627 \u0635\u0627\u062F\u0631 \u0648 \u0628\u0631\u0627\u06CC \u0634\u0645\u0627 \u0627\u06CC\u0645\u06CC\u0644 \u0645\u06CC\u06AF\u0631\u062F\u062F."} hideBottomLine={true} iconName="fact_check" stepNumber={6} title={"\u0635\u062F\u0648\u0631 \u0648\u06CC\u0632\u0627"} /></ol>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};